import _ from "lodash"


export const fetchManifestUrl = (labDependencyUrl) => {
  return fetch(labDependencyUrl)
  .then(data => data.json())
  .then(data => _.get(data, 'SUBTYPES_COMMON.1.resources.0.download_url'))
}
